import { render } from "./PhotoChkView.vue?vue&type=template&id=90f76ef0"
import script from "./PhotoChkView.vue?vue&type=script&lang=js"
export * from "./PhotoChkView.vue?vue&type=script&lang=js"

import "./PhotoChkView.vue?vue&type=style&index=0&id=90f76ef0&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__